import { Client, Account, Databases, Storage, ID, Permission, Role } from "appwrite";

// ── Singleton client ──────────────────────────────────────────────────────────
const client = new Client()
    .setEndpoint((import.meta as any).env.VITE_APPWRITE_ENDPOINT as string)
    .setProject((import.meta as any).env.VITE_APPWRITE_PROJECT_ID as string);

export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const CLIENT = client;

export const ENDPOINT = (import.meta as any).env.VITE_APPWRITE_ENDPOINT as string;
export const PROJECT_ID = (import.meta as any).env.VITE_APPWRITE_PROJECT_ID as string;

// ── Constants ─────────────────────────────────────────────────────────────────
export const DB_ID = (import.meta as any).env.VITE_APPWRITE_DATABASE_ID as string;
export const BUCKET_ID = (import.meta as any).env.VITE_APPWRITE_BUCKET_ID as string;

export const COLLECTIONS = {
    ENQUIRIES: "enquiries",
    BLOG_POSTS: "blog_posts",
    PRODUCTS: "products",
    SERVICES: "services",
    PROJECTS: "projects",
} as const;

// Re-export helpers so pages don't need extra imports
export { ID, Permission, Role };

// ── Session Helper ───────────────────────────────────────────────────────────
/**
 * Ensures an anonymous session exists. 
 * Prevents race conditions during concurrent data fetches on fresh loads.
 */
export async function ensureSession() {
    try {
        await account.get();
    } catch {
        try {
            await account.createAnonymousSession();
        } catch (err) {
            console.error("Failed to create anonymous session:", err);
        }
    }
}
